import React, { useEffect, useState } from 'react';
import { Alert, Spin } from 'antd';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import PageTitle from '../../components/layout/PageTitle';
import Song from '../../components/Song';
import { PageContent, SideBar, TitleContainer } from '../../components/layout/style';
import VideoPlayer from '../../components/VideoPlayer';
import UsedChordsList from '../../components/UsedChordsList';
import TabPlayer from '../../components/tabs/TabPlayer';
import TabLoader from '../../components/tabs/TabLoader';
import ChordsHint from '../../components/layout/ChordsHint';
import SongRepository from '../../service/SongRepository';
import SongBlock from '../../components/layout/SongsBlock';

const SongPart = ({ title, id, children }) => {
  return <div>
    <TitleContainer style={{ paddingBottom: 0 }}>{title}</TitleContainer>
    <div id={id}>
      {children}
    </div>
  </div>
};

const SongContainer = styled.div`
    min-height: 200px;
`;

const VideoTitle = styled.div`
    color: #333;
`;

export default function SongPage({ song: preloadedSong }) {
  const router = useRouter();
  const { song: songCode } = router.query;

  const [loading, setLoading] = useState(false);
  const [song, setSong] = useState(preloadedSong);
  const [error, setError] = useState();

  useEffect(() => {
    if (!song || song.code !== songCode) {
      loadSong(songCode);
    }
  }, [song, songCode]);

  const loadSong = async (code) => {
    try {
      setLoading(true);
      setSong(await SongRepository.getSong(code));
    } catch (e) {
      setError('Не удалось загрузить текст песни');
    } finally {
      setLoading(false);
    }
  };

  const renderVideos = (videos) => {
    if (!videos) {
      return null;
    }

    return <SongPart id='video' title={'Видео'}>
      {Array.isArray(videos) ? videos.map((video, key) => renderPlayer(video, key)) : renderPlayer({ id: videos })}
    </SongPart>;
  }

  const renderPlayer = (video, key) => {
    return <div key={`video-${key}`}>
      {video.title && <VideoTitle>{video.title}</VideoTitle>}
      <VideoPlayer videoId={video.id}/>
    </div>
  }

  const renderSong = (song) => {
    if (!song) {
      return null;
    }

    const author = song.author ? song.author : 'Народная';

    return <div className=''>
      <PageTitle
          title={song.title}
          subtitle={author}
          metaTitle={`${song.title} [${author}] - аккорды для гуслей`}/>
      <Song text={song.text}/>

      {song.hasTabs && <SongPart title={'Табулатура'} id='tabs'>
        <TabLoader tabCode={song.code} renderPlayer={(tabs) => <TabPlayer song={tabs}/>}/>
      </SongPart>}

      {renderVideos(song.video)}
    </div>
  };

  return <>
    <PageContent>
      <Spin tip={'Загрузка'} spinning={loading}>
        {error && <Alert message={error} type='error'/>}
        <SongContainer>
          {renderSong(song)}
        </SongContainer>
      </Spin>
    </PageContent>
    <SideBar>
      <UsedChordsList/>
      <ChordsHint/>
      <SongBlock/>
    </SideBar>
  </>
}

SongPage.getInitialProps = async ({ req, query }) => {
  if (!req) {
    return {};
  }

  const { song } = query;

  return {
    key: Number(new Date()),
    song: await SongRepository.getSong(song, req.headers.host),
  };
};
